'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTheme = require('@narvar/nth-hook-theme');
var index = require('../Language/index.js');
require('../Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../LocationCard/LocationCard.js');
require('../PudoCard/PudoCard.js');
require('../ItemCard/ItemCard.js');
require('../SelectItem/SelectItem.js');
require('../SelectList/SelectList.js');
require('../ErrorBanner/ErrorBanner.js');
require('../Footer/Footer.js');
require('../StickyFooter/StickyFooter.js');
require('../SwatchesList/SwatchesList.js');
require('@narvar/nth-bit-text-link');
require('../Backdrop/Backdrop.module.css.js');
require('../Skeleton/Skeleton.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const LineItemsGroupC = _ref => {
  let {
    selectedGroup,
    itemsWereSelected,
    children
  } = _ref;
  const {
    bodytextDefaultNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, !selectedGroup && itemsWereSelected && /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      ...bodytextDefaultNone,
      margin: '1.5rem auto 1rem auto'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsLineItemGroupIneligibleDescription"
  })), children);
};
const LineItemsGroup = nthHookTheme.withThemeProvider(LineItemsGroupC, {
  themeTokens: ['bodytextDefaultNone']
});

exports.LineItemsGroup = LineItemsGroup;
